import React from 'react'
import { css } from '@emotion/core'
import { useFormikContext } from 'formik'
import { array } from 'yup'
import { graphql, useStaticQuery } from 'gatsby'
import nanoid from 'nanoid'
import { dynamicCol } from '@/styles/shared'
import { mq } from '@/styles/theme'

const checkboxesStyles = css`
  justify-items: flex-start;

  ${mq.greaterThan('small')`
    grid-auto-flow: unset;
    grid-gap: calc(var(--d-gutter) / 3);
  `};
`

const checkboxLabelStyles = css`
  display: grid;
  grid-gap: 0 10px;
  grid-auto-flow: column;
  justify-content: start;
  cursor: pointer;

  input {
    positioy: relative;
    top: 3px;
  }
`

const fieldName = 'interested-in'

const interestOptions = [
  { label: '15 Craigside', value: '15 Craigside' },
  { label: 'Arcadia', value: 'Arcadia' },
  { label: 'At Home', value: 'At Home' },
  { label: 'Home Care', value: 'Home Care' },
  { label: 'Adult Day Care', value: 'Adult Day Care' },
  { label: 'Other Questions/Comments', value: 'Other Questions/Comments' },
]

const Component = () => {
  const {
    values,
    handleChange,
    handleBlur,
    setFieldTouched,
    touched,
    errors,
    submitCount,
  } = useFormikContext()
  //const {
  //  prismicGlobalSettings: {
  //    data: { formInterestOptions },
  //  },
  //} = useStaticQuery(query)
  return (
    <div>
      <p className="label-text">Interested In*</p>
      <div css={[dynamicCol, checkboxesStyles]}>
        {interestOptions.map(({ label, value }) => (
          <label css={checkboxLabelStyles} key={nanoid()}>
            <input
              type="checkbox"
              name={fieldName}
              onBlur={e => {
                setFieldTouched(fieldName, true)
                handleBlur(e)
              }}
              onChange={e => {
                setFieldTouched(fieldName, true)
                handleChange(e)
              }}
              value={value}
              checked={values[fieldName] && values[fieldName].includes(label)}
            />
            <span>{label}</span>
          </label>
        ))}
      </div>
      {(touched[fieldName] || submitCount >= 1) && errors[fieldName] && (
        <p className="field-error">{errors[fieldName].replace('interested-in', 'Interested In')}</p>
      )}
    </div>
  )
}

// const schema = array().test(
//   fieldName,
//   'Please choose at least one referral',
//   referrals => referrals && referrals.length >= 1
// )

const schema = array()

// const schema = {
//   initialValue: [],
//   label: 'Interested In',
// };

// const query = graphql`
//   {
//     prismicGlobalSettings {
//       data {
//         formInterestOptions: form_interest_options {
//           option: form_interest_option
//         }
//       }
//     }
//   }
// `

export default {
  Component,
  schema,
}
